import { PASSPORT_URI, ACCOUNT_SERVICE_URI, MESSAGE_SERVICE_URI } from 'library-components/config/envConfig.js';
import { transformUrlProxy, SLD } from '@patsnap-utils/biz';

export const baseAuthServer = transformUrlProxy(SLD.PASSPORT, PASSPORT_URI);
export const baseUserServer = ACCOUNT_SERVICE_URI;

export const userBasicApiUrlPrefix = `${baseUserServer}/user-service`;
export const messageServiceApiUrlPrefix = `${MESSAGE_SERVICE_URI}/emailservice`;
